// 是否续约
export const CONTINUOUS_MAP = {
  1: {
    name: '是',
    value: 1,
  },
  0: {
    name: '否',
    value: 0,
  },
}
export const CONTINUOUS_LIST = Object.values(CONTINUOUS_MAP)

// 租赁阶段
export const LEASE_PHASE_MAP = {
  1: {
    name: '已租<30天',
    value: 1,
  },
  2: {
    name: '已租>=30天',
    value: 2,
  },
}
export const LEASE_PHASE_LIST = Object.values(LEASE_PHASE_MAP)

// 昨日网约状态
export const ONLINE_RIDE_STATUS_MAP = {
  1: {
    name: '未注册',
    value: 1,
  },
  2: {
    name: '运营中',
    value: 2,
  },
  3: {
    name: '封号中',
    value: 3,
  },
  4: {
    name: '已注销',
    value: 4,
  },
}
export const ONLINE_RIDE_STATUS_LIST = Object.values(ONLINE_RIDE_STATUS_MAP)

// 昨日出车状态
export const WORK_STATUS_MAP = {
  1: {
    name: '新增出车',
    value: 1,
  },
  2: {
    name: '留存出车',
    value: 2,
  },
  3: {
    name: '回流出车',
    value: 3,
  },
}
export const WORK_STATUS_LIST = Object.values(WORK_STATUS_MAP)

// 昨日不可出车原因
export const NO_WORK_REASON_MAP = {
  1: {
    name: '网约封号',
    value: 1,
  },
  2: {
    name: '车辆维修',
    value: 2,
  },
  3: {
    name: '车辆保养',
    value: 3,
  },
  4: {
    name: '其他原因',
    value: 4,
  },
}
export const NO_WORK_REASON_LIST = Object.values(NO_WORK_REASON_MAP)

// 出车率分级
export const WORK_RATE_MAP = {
  1: {
    name: '极低',
    value: 1,
  },
  2: {
    name: '较低',
    value: 2,
  },
  3: {
    name: '一般',
    value: 3,
  },
  4: {
    name: '较高',
    value: 4,
  },
  5: {
    name: '极高',
    value: 5,
  },
}
export const WORK_RATE_LIST = Object.values(WORK_RATE_MAP)

// 取消率分级
export const CANCEL_RATE_MAP = {
  1: {
    name: '极低',
    value: 1,
  },
  2: {
    name: '较低',
    value: 2,
  },
  3: {
    name: '一般',
    value: 3,
  },
  4: {
    name: '较高',
    value: 4,
  },
  5: {
    name: '极高',
    value: 5,
  },
}
export const CANCEL_RATE_LIST = Object.values(CANCEL_RATE_MAP)

// 出车时长分级
export const WORK_DURATION_MAP = {
  1: {
    name: '极少',
    value: 1,
  },
  2: {
    name: '较少',
    value: 2,
  },
  3: {
    name: '一般',
    value: 3,
  },
  4: {
    name: '较多',
    value: 4,
  },
  5: {
    name: '极多',
    value: 5,
  },
}
export const WORK_DURATION_LIST = Object.values(WORK_DURATION_MAP)

// TPH分级
export const TPH_MAP = {
  1: {
    name: '极低',
    value: 1,
  },
  2: {
    name: '较低',
    value: 2,
  },
  3: {
    name: '一般',
    value: 3,
  },
  4: {
    name: '较高',
    value: 4,
  },
  5: {
    name: '极高',
    value: 5,
  },
}
export const TPH_LIST = Object.values(TPH_MAP)

// IPH分级
export const IPH_MAP = {
  1: {
    name: '极低',
    value: 1,
  },
  2: {
    name: '较低',
    value: 2,
  },
  3: {
    name: '一般',
    value: 3,
  },
  4: {
    name: '较高',
    value: 4,
  },
  5: {
    name: '极高',
    value: 5,
  },
}
export const IPH_LIST = Object.values(IPH_MAP)

// 服务分分级
export const SERVICE_SCORE_MAP = {
  1: {
    name: '极低',
    value: 1,
  },
  2: {
    name: '较低',
    value: 2,
  },
  3: {
    name: '一般',
    value: 3,
  },
  4: {
    name: '较高',
    value: 4,
  },
  5: {
    name: '极高',
    value: 5,
  },
}
export const SERVICE_SCORE_LIST = Object.values(SERVICE_SCORE_MAP)
